import PropTypes from 'prop-types';
import React from 'react';
import { getItemFromStore } from 'helpers/utils';

const CheckedByLink = ({
  handleChangeValue,
  property,
  text = 'Checked By Me'
}) => {
  const currentUser = getItemFromStore('user', {}, sessionStorage)?.userId ?? 0;
  // const currentUser = useSelector(state => state.user.userId);
  const handleCheckedByMe = e => {
    e.preventDefault();
    console.log(currentUser);

    handleChangeValue(currentUser, property);
  };

  return (
    <a href="" onClick={handleCheckedByMe}>
      {text}
    </a>
  );
};

CheckedByLink.propTypes = {
  handleChangeValue: PropTypes.func,
  property: PropTypes.string,
  text: PropTypes.string
};

export default CheckedByLink;
